<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--md">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-percent-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">Générer prix normalisé</h4>
                                <p class="cf-modal-head__sub">Application d'une marge (%)</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">
                        <div class="cf-note cf-note--warn">
                            <i class="ri-error-warning-line"></i>
                            <span>
                                Cette option applique automatiquement une marge (%) au prix de vente de base pour obtenir un prix normalisé.
                                <br><br>
                                <strong>Attention :</strong> le système modifiera le <strong>PRIX DE VENTE PAR DÉFAUT 7</strong>. Cette opération est irréversible — analysez soigneusement avant validation.
                            </span>
                        </div>

                        <div style="margin-top:1rem;max-width:220px;margin-left:auto;margin-right:auto;text-align:center;">
                            <label class="cf-field-label">Marge (%)</label>
                            <input v-model="margepourcentage" min="0" type="number" class="cf-inp" style="text-align:center;" required />
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        <button @click="updateMaj" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-check-line align-middle"></i> Appliquer
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>

 import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",


        computed:{

        },
        components: {


        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                messageerror:"",
                messagesucces:"",
                margepourcentage:0,


            };
        },
        methods: {

            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },


          async  show(){
                this.messagesucces="";
                this.messageerror="";

              this.margepourcentage=0
/*
              window.Swal.fire({
                  title: 'Alerte',
                  html: "<span style='color: red; font-weight: bold;'>Aucune année d'exercice n’est active pour le traitement des salaires.</span>",
                  icon: 'warning',
                  confirmButtonText: 'D’accord',
                  customClass: {
                      confirmButton: 'swal-confirm-red'
                  },
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  reverseButtons: true
              }).then((result) => {
                  if (result.isConfirmed) {
                      console.log('Enregistrement confirmé.')
                      // Ta logique ici
                  } else {
                      console.log('Action annulée.')
                  }
              });
*/

                   this.isdisplay=true;

            },


                 async updateMaj(){
                     if (this.margepourcentage<=0){

                         toastr['error']("Veuillez saisir un poucentage valide....","<b></b>");

                     }


                     const confirmed = window.confirm(
                         " Confirmez-vous l'application de la marge (%) au prix de base ?\n Attention : Modification irréversible du prix par défaut. Vérifiez bien votre choix."
                     );

                     if (!confirmed) {
                         return ;
                     }


                     const t = this;
                            t.$store.dispatch('lancerchargement',true)
                                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/upditems/punormaliser/'+this.$store.state.appsociete+'/'+randomString();
                                let response =   axios  .post(url,{pu:this.margepourcentage},{
                                    headers: {
                                        'X-Requested-With': 'XMLHttpRequest',
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + JwtService.getToken(),
                                        'csrftoken': this.$store.state.appsociete
                                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                                })

                                let res= await response
                                    .then(function (res){
                                        t.$store.dispatch('lancerchargement',false)


                                        if(res.data.success){




                                            window.Swal.fire({
                                                title: 'Alerte',
                                                html: "<span style='font-weight: bold;'>La mise à jour a été effectuée avec succès.</span>",
                                                icon: 'success',
                                                confirmButtonText: 'D’accord',
                                                customClass: {
                                                    confirmButton: 'swal-confirm-red'
                                                },
                                                allowOutsideClick: false,
                                                allowEscapeKey: false,
                                                reverseButtons: true
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    t.close();
                                                    // Ta logique ici
                                                } else {
                                                    console.log('Action annulée.')
                                                }
                                            });



                                        }
                                        else{
                                            t.close();
                                        }


                                    })
                                    .catch((error)=>{

                                            t.$store.dispatch('lancerchargement',false)
                                        }
                                    )
                                    .finally(() =>{

                                       // t.$store.dispatch('lancerchargement',false)


                                    })




            },

        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--md { max-width:560px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.cf-field-label { display:block; font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); margin-bottom:6px; }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--md { max-width:100%; } }
</style>
